/**
 * Pro Resources — Search, Filter & Form Logic
 * Server-rendered cards; this script only filters the DOM and validates the quote form.
 */
(function () {
  'use strict';

  // Family chip swatch colors. Keys are UPPERCASE-normalized family names
  // (matches data-family, which is product.metafields.product.family | upcase).
  // Refreshed 2026-06-23 (R-04267652) to current catalog family names: COASTAL
  // SERIN -> COASTAL, SEDONA LOFT -> LOFT, plus added CAMBRIDGE, EURO, PRESTIGE,
  // DRAIN / HEATER, UNIVERSAL/ NO FAMILY. Renamed families previously fell
  // through to the gray fallback. Any unmapped family still renders FALLBACK_COLOR.
  var FAMILY_COLORS = {
    'ASPIRATIONS': '#0097A9',
    'BOOTZCAST': '#3F3F46',
    'CADET': '#7C5C3C',
    'CAMBRIDGE': '#155E75',
    'COASTAL': '#1E40AF',
    'DRAIN / HEATER': '#52525B',
    'ELEVATE': '#5B6ABF',
    'ESTATE': '#6D28D9',
    'EURO': '#0D9488',
    'EVERCLEAN': '#2563EB',
    'EVOLUTION': '#0E7490',
    'HONOLULU': '#0E7490',
    'KONA': '#65A30D',
    'LOFT': '#92400E',
    'MAINSTREAM': '#1E3A8A',
    'NEXTILE': '#9F1239',
    'OVATION': '#0F766E',
    'PASSAGE': '#7C3AED',
    'PRESTIGE': '#B45309',
    'PRINCETON': '#1F2937',
    'PRINCETON PRO': '#374151',
    'SHOWERCAST': '#475569',
    'STUDIO': '#6B21A8',
    'STUDIO S': '#9333EA',
    'TOWN SQUARE S': '#8B5CF6',
    'TOWNSEND': '#4338CA',
    'UNIVERSAL/ NO FAMILY': '#6B7280',
    'OTHER': '#6B7280'
  };
  var FALLBACK_COLOR = '#6B7280';

  var activeTypeFilter = 'All';
  var activeFamilyFilter = 'All';
  var activeTradeFilter = 'All';
  var searchQuery = '';
  var debounceTimer;

  function init() {
    if (!document.querySelector('[data-pro-resources]')) return;
    paintFamilyColors();
    bindFilterChips();
    bindSearch();
    bindForm();
    updateCounts();
  }

  function paintFamilyColors() {
    var nodes = document.querySelectorAll('.js-pro-family-bg');
    for (var i = 0; i < nodes.length; i++) {
      var family = (nodes[i].getAttribute('data-family') || '').toUpperCase();
      nodes[i].style.background = FAMILY_COLORS[family] || FALLBACK_COLOR;
    }
  }

  function bindFilterChips() {
    document.addEventListener('click', function (e) {
      var typeChip = e.target.closest('[data-filter-type]');
      if (typeChip) {
        activeTypeFilter = typeChip.getAttribute('data-filter-type');
        setActiveChip('type', activeTypeFilter);
        applyFilters();
        return;
      }
      var familyChip = e.target.closest('[data-filter-family]');
      if (familyChip) {
        activeFamilyFilter = familyChip.getAttribute('data-filter-family');
        setActiveChip('family', activeFamilyFilter);
        applyFilters();
        return;
      }
      var tradeChip = e.target.closest('[data-filter-trade]');
      if (tradeChip) {
        activeTradeFilter = tradeChip.getAttribute('data-filter-trade');
        setActiveChip('trade', activeTradeFilter);
        applyFilters();
      }
    });
  }

  var CHIP_ATTRS = {
    type: 'data-filter-type',
    family: 'data-filter-family',
    trade: 'data-filter-trade'
  };

  function setActiveChip(group, value) {
    var attr = CHIP_ATTRS[group];
    var chips = document.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.toggle('pro-resources-chip--active', chips[i].getAttribute(attr) === value);
    }
  }

  function bindSearch() {
    // Support multiple search inputs (one per section). Whichever the user
    // types in drives the shared query and mirrors its value to the others.
    var inputs = document.querySelectorAll('.js-pro-search, #pro-resources-search');
    if (!inputs.length) return;
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function (e) {
        var value = e.target.value;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          searchQuery = value.trim().toLowerCase();
          for (var j = 0; j < inputs.length; j++) {
            if (inputs[j] !== e.target) inputs[j].value = value;
          }
          applyFilters();
        }, 200);
      });
    }
  }

  function applyFilters() {
    var grids = document.querySelectorAll('.pro-resources-results__grid');
    for (var g = 0; g < grids.length; g++) {
      var cards = grids[g].querySelectorAll('.js-pro-card');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var family = card.getAttribute('data-family') || '';
        var type = card.getAttribute('data-type') || '';
        var trade = card.getAttribute('data-trade') || '';
        var search = card.getAttribute('data-search') || '';

        var visible = true;
        if (activeTypeFilter !== 'All' && type !== activeTypeFilter) visible = false;
        if (visible && activeFamilyFilter !== 'All' && family !== activeFamilyFilter) visible = false;
        if (visible && activeTradeFilter !== 'All' && trade !== activeTradeFilter) visible = false;
        if (visible && searchQuery && search.indexOf(searchQuery) === -1) visible = false;

        card.style.display = visible ? '' : 'none';
      }
    }
    updateCounts();
  }

  function updateCounts() {
    var counters = document.querySelectorAll('.pro-resources-results__count');
    for (var c = 0; c < counters.length; c++) {
      var counter = counters[c];
      var mode = counter.getAttribute('data-mode');
      var grid = document.getElementById('pro-resources-' + mode + '-grid');
      if (!grid) continue;
      var cards = grid.querySelectorAll('.js-pro-card');
      var total = parseInt(counter.getAttribute('data-total'), 10) || cards.length;
      var visible = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].style.display !== 'none') visible++;
      }
      counter.innerHTML = 'Showing <strong>' + visible + '</strong> of <strong>' + total + '</strong> products';

      var empty = grid.querySelector('.pro-resources-empty');
      if (visible === 0 && total > 0) {
        if (!empty) {
          empty = document.createElement('div');
          empty.className = 'pro-resources-empty';
          empty.innerHTML = '<div class="pro-resources-empty__icon"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div><p class="pro-resources-empty__text">No products match your search. Try a different SKU or product name.</p>';
          grid.appendChild(empty);
        }
      } else if (empty) {
        empty.remove();
      }
    }
  }

  // The quote form is Shopify's native {% form 'contact' %}. Only invalid submits
  // are blocked; valid ones post to /contact and the section renders the thank-you
  // state from form.posted_successfully?. Never fake a success state here.
  function bindForm() {
    var form = document.getElementById('pro-resources-quote-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) e.preventDefault();
    });
  }

  function validateForm(form) {
    var required = form.querySelectorAll('[required]');
    var valid = true;
    for (var i = 0; i < required.length; i++) {
      var field = required[i];
      field.style.borderColor = '';
      if (!field.value.trim()) {
        field.style.borderColor = '#E4002B';
        valid = false;
      }
      if (field.type === 'email' && field.value.trim()) {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(field.value.trim())) {
          field.style.borderColor = '#E4002B';
          valid = false;
        }
      }
    }
    return valid;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
